import { Component, Input, OnInit } from '@angular/core';
import { PatientConsultation } from '@models/data/patient-consultations/PatientConsultation';
import { LocalizeService } from '@services/helpers/localize/localize.service';
import { ModalService } from '@services/helpers/modal/modal.service';
import { UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { environment } from '@environments/environment';
import { PatientConsultationService } from '@services/core/patient-consultation/patient-consultation.service';
import { AlertService } from '@services/helpers/alert/alert.service';
import { PatientConsultationFormData } from '@models/data/patient-consultations/interfaces/PatientConsultationFormData';
import { LocalizeTextPipe } from '@shared/pipes/localize-text/localize-text.pipe';
import { ButtonComponent } from '../../../../../shared/components/buttons/button/button.component';
import { FormControlErrorDirective } from '../../../../../shared/directives/form-control-error/form-control-error.directive';
import { ModalComponent } from '../../../../../shared/components/modal/modal.component';

@Component({
    selector: 'app-patient-consultation-form',
    templateUrl: './patient-consultation-form.component.html',
    styleUrls: ['./patient-consultation-form.component.scss'],
    standalone: true,
    imports: [ModalComponent, ReactiveFormsModule, FormControlErrorDirective, ButtonComponent, LocalizeTextPipe]
})
export class PatientConsultationFormComponent implements OnInit {
  @Input() patientFitMedProfileId: string;
  @Input() tenantId: string;
  @Input() updating: boolean;
  @Input() updatingConsult: PatientConsultation; // The object reference for the consultation being updated
  public updateRequired = false;
  title: string;

  loading$ = false;

  patientConsultationForm = new UntypedFormGroup({
    notes: new UntypedFormControl(environment.production ? '' : 'My Notes', [
      Validators.required,
    ]),
  });

  constructor(
    private localizeService: LocalizeService,
    private modalService: ModalService,
    private pcService: PatientConsultationService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.setupModal();
  }

  private setupModal(): void {
    // Title
    const titleLocaleKey = this.updating
      ? 'UpdatingPatientConsultation'
      : 'CreatingPatientConsultation';
    this.title = this.localizeService.l(titleLocaleKey);

    // The consult object being updated
    if (this.updatingConsult) {
      this.patientConsultationForm
        .get('notes')
        .setValue(this.updatingConsult.notes);
    }

    if (!environment.production && !this.patientFitMedProfileId) {
      this.alertService.danger('patientPractitionerId was not pushed into the patient consultation form');
    }
  }

  private getFormData(): PatientConsultationFormData {
    return this.patientConsultationForm.getRawValue();
  }

  saveConsultationNotes(): void {
    const formData = this.getFormData();
    formData.patientFitMedProfileId = this.patientFitMedProfileId
    this.loading$ = true;

    let createOrUpdate;
    let successMsg = this.localizeService.l('Note', 'Note');
    if (this.updating) {
      successMsg += ' ' + this.localizeService.l('UpdatedSuccessfully', 'Updated successfully');
      createOrUpdate = this.pcService.updateInTenant(
        this.updatingConsult.id,
        formData,
        this.tenantId
      );
    } else {
      successMsg += ' ' + this.localizeService.l('CreatedSuccessfully', 'Created successfully');
      createOrUpdate = this.pcService.createInTenant(formData, this.tenantId);
    }

    // Handle the success of create or update
    createOrUpdate.then((_) => {
      this.alertService.success(successMsg);
      this.updateRequired = true;
      // this.modalService.content.updateRequired = true;
      this.modalService.closeAll();
      this.loading$ = false;
    });
  }
}
